const DEFAULT_CURRENCY_CODE = 'UGX';

const getFractionDigits = (currencyCode: string) => {
  if (currencyCode === 'USD') {
    return 2;
  }
  return 0;
};

const safeCurrencyCode = (currencyCode?: string) => currencyCode || DEFAULT_CURRENCY_CODE;

export const formatCurrency = (
  amount: number | string | undefined,
  currencyCode?: string
): string => {
  if (amount === null || amount === undefined) {
    return `${safeCurrencyCode(currencyCode)} 0`;
  }

  const num = Number(amount);
  if (isNaN(num)) {
    return `${safeCurrencyCode(currencyCode)} 0`;
  }

  const code = safeCurrencyCode(currencyCode);

  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: code,
      currencyDisplay: 'code',
      minimumFractionDigits: getFractionDigits(code),
      maximumFractionDigits: getFractionDigits(code),
    }).format(num);
  } catch (error) {
    return `${code} ${num.toLocaleString('en-US', {
      minimumFractionDigits: getFractionDigits(code),
      maximumFractionDigits: getFractionDigits(code),
    })}`;
  }
};

export const formatCurrencySimple = (
  amount: number | string | undefined,
  currencyCode?: string
): string => {
  return formatCurrency(amount, currencyCode);
};

export const CURRENCY_SYMBOL = DEFAULT_CURRENCY_CODE;
